import Icon from '../Icon/Icon';
import * as Styled from './Spinner.styled';
import { SpinnerProps } from './Spinner.typed';

export function Spinner(props: SpinnerProps) {
  const { color, ...rest } = props;
  return (
    <Styled.Spinner data-testid="spinner" {...rest}>
      <Icon name="Spinner" size="m" {...(!!color && { color })} />
    </Styled.Spinner>
  );
}

export default Spinner;
